import React from 'react';
import { Alert, Button } from 'antd';
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import './ErrorNotification.css';

const ErrorNotification = ({ 
  visible, 
  onClose, 
  onRetry, 
  title = "Error al procesar formulario F23",
  message = "Ha ocurrido un error inesperado. Por favor, inténtalo nuevamente.",
  showRetry = true 
}) => {
  if (!visible) return null;

  return (
    <div className="error-notification">
      <Alert
        message={title}
        description={message}
        type="error"
        showIcon
        action={
          <div className="error-notification-actions">
            {showRetry && (
              <Button 
                size="small" 
                danger 
                icon={<ReloadOutlined />}
                onClick={onRetry}
              >
                Reintentar
              </Button>
            )}
            <Button 
              size="small" 
              type="text" 
              icon={<CloseOutlined />}
              onClick={onClose}
            />
          </div>
        }
        closable={false}
      />
    </div>
  );
};

export default ErrorNotification;
